import React from 'react';
import { useInternationalization } from '../../features/i18n';
import { GalleryDropzone } from './gallery-dropzone';
import { GalleryDropzonePreview } from './gallery-dropzone-preview';

/**
 *
 * @param {Function} onChange
 *
 */
const GalleryForm = ({
  label,
  onChange = (e) => { console.log(e) },
  message
}) => {
  const [galleryObjects, setGalleryObjects] = React.useState([])
  const [galleryItems, setGalleryItems] = React.useState([])
  const { translate } = useInternationalization()
  const finalLabel = label ? label : translate('GENERAL', 'gallery')

  const generateBlobs = (images) => {
    const blobs = []

    if (images && images.length > 0){
      for (let index = 0; index < images.length; index++) {
        const image = images[index];
        const blob = URL.createObjectURL(image)
        blobs.push(blob)
      }
    }

    return blobs
  }

  const handleImages = (images) => {
    const newGalleryObjects = [...galleryObjects, ...images]
    setGalleryObjects(newGalleryObjects)

    // Handle payload and local state
    const blobs = generateBlobs(images)
    const newGalleryItems = [...galleryItems, ...blobs]
    setGalleryItems(newGalleryItems)

    // Side effect; pass to props
    onChange({blobs: newGalleryItems, images: newGalleryObjects})
  }

  const handleRemoveImage = (index) => {
    const cloned = [...galleryItems]
    const filtered = cloned.filter((image, i) => i !== index)
    setGalleryItems(filtered)
  }

  return (
    <>
      {/* Input */}
      <div className="mb-8 lg:mb-10">
        <GalleryDropzone
          label={finalLabel}
          onChange={handleImages}
          message={message}
        />
      </div>

      {/* Preview */}
      <GalleryDropzonePreview
        items={galleryItems}
        onRemove={handleRemoveImage}
      />
    </>
  )
}

export { GalleryForm }
